import {EToastTypes} from 'models';
import {IToast} from 'utils/interfaces';

export const showToastAction = (payload: IToast) => ({
    type: EToastTypes.SHOW_TOAST_ELEMENT,
    payload,
});
